import { useEffect, useState } from 'react'

import DateFnsUtils from '@date-io/date-fns'
import { Grid } from '@material-ui/core'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { FormikAutocomplete } from 'Components/UI/Atoms/CustomAutocomplete'
import { format, isValid, parse } from 'date-fns'
import es from 'date-fns/locale/es'
import { Field } from 'formik'
import { TextField } from 'formik-material-ui'

import useStyles from './styles'

export default function InputsWithValidate(props) {
  const { spacing, fields, setFieldValue, isSubmitting } = props
  const classes = useStyles()
  const DatePickerField = ({ field, form, strictManualDate = false, ...other }) => {
    const currentError = form.errors[field.name]

    const effectiveAllowManualDate = Boolean(strictManualDate)

    const rawValue = field.value
    const pickerValue = rawValue instanceof Date && !isNaN(rawValue) ? rawValue : null

    const pickerInputValue = typeof rawValue === 'string' ? rawValue : ''
    const [manualInput, setManualInput] = useState(pickerInputValue)

    useEffect(() => {
      if (!effectiveAllowManualDate || !strictManualDate) return
      setManualInput(pickerInputValue)
    }, [effectiveAllowManualDate, strictManualDate, pickerInputValue])

    const parseStrictDay = (typed) => {
      if (typeof typed !== 'string' || typed.length !== 10) return null
      const parsed = parse(typed, 'dd-MM-yyyy', new Date())
      const isStrictMatch = isValid(parsed) && format(parsed, 'dd-MM-yyyy') === typed
      return isStrictMatch ? parsed : null
    }

    const focusDateInput = () => {
      window.requestAnimationFrame(() => {
        const input = document.querySelector(`input[name="${field.name}"]`)
        if (input && document.activeElement !== input) {
          input.focus()
        }
      })
    }

    const keepFocusOnSelect = Boolean(other.keepFocusOnSelect)

    return effectiveAllowManualDate ? (
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
        <KeyboardDatePicker
          okLabel=""
          cancelLabel=""
          clearLabel
          clearable={field.cleareable}
          autoOk={true}
          inputVariant="outlined"
          variant="inline"
          fullWidth
          inputValue={strictManualDate ? manualInput : field.inputValue}
          views={field.views ? field.views : undefined}
          name={field.name}
          value={strictManualDate ? pickerValue : field.value === '' ? null : field.value}
          defaultValue={field.defaultValue}
          format={effectiveAllowManualDate ? 'dd-MM-yyyy' : field.format || 'yyyy'}
          helperText={currentError}
          error={Boolean(currentError)}
          onChange={
            strictManualDate
              ? (date, keyboardInputValue) => {
                  const typed = typeof keyboardInputValue === 'string' ? keyboardInputValue : ''
                  setManualInput(typed)

                  if (date instanceof Date && isValid(date) && typed.length === 10) {
                    const isStrictMatch = format(date, 'dd-MM-yyyy') === typed
                    if (isStrictMatch) {
                      form.setFieldValue(field.name, date, true)
                      if (keepFocusOnSelect) focusDateInput()
                    }
                  }
                }
              : (date) => {
                  if (date instanceof Date && !isNaN(date)) {
                    form.setFieldValue(field.name, date, true)
                    if (keepFocusOnSelect) focusDateInput()
                  }
                }
          }
          onBlur={
            strictManualDate
              ? (e) => {
                  const typed = typeof e?.target?.value === 'string' ? e.target.value : manualInput
                  setManualInput(typed)
                  const parsedStrict = parseStrictDay(typed)
                  form.setFieldValue(field.name, parsedStrict ?? typed, true)
                  form.handleBlur(e)
                }
              : undefined
          }
          InputLabelProps={{ shrink: true }}
          InputProps={{
            ...other.InputProps,
            readOnly: !effectiveAllowManualDate,
          }}
          KeyboardButtonProps={{
            tabIndex: -1,
          }}
          {...other}
        />
      </MuiPickersUtilsProvider>
    ) : (
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
        <KeyboardDatePicker
          okLabel=""
          cancelLabel=""
          clearLabel
          clearable={field.cleareable}
          autoOk={true}
          inputVariant="outlined"
          variant="inline"
          fullWidth
          inputValue={field.inputValue}
          views={field.views ? field.views : undefined}
          name={field.name}
          value={field.value}
          defaultValue={field.defaultValue}
          format={field.format ? field.format : 'yyyy'}
          helperText={currentError}
          error={Boolean(currentError)}
          onChange={(date) => form.setFieldValue(field.name, date, true)}
          {...other}
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{ readOnly: true }}
          KeyboardButtonProps={{
            tabIndex: -1,
          }}
        />
      </MuiPickersUtilsProvider>
    )
  }
  return (
    <div>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        alignContent="center"
        spacing={spacing}
      >
        {fields.map((field, index) => {
          if (field.class === 'textfield') {
            if (field.onChange) {
              return (
                <Grid item sm={field.sm} key={index} xs={field.xs}>
                  <Field
                    component={TextField}
                    disabled={field.disabled}
                    multiline={field.multiline}
                    rows={field.rows}
                    type={field.type}
                    style={field.style}
                    className={classes.heightsForm}
                    label={field.label}
                    name={field.name}
                    initialValue={field.value}
                    onChange={field.onChange}
                    variant="outlined"
                    fullWidth
                    value={field.value}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={field.inputProps}
                    autoFocus={field.autoFocus}
                  />
                </Grid>
              )
            } else {
              return (
                <Grid item sm={field.sm} key={index} xs={field.xs}>
                  <Field
                    component={TextField}
                    disabled={field.disabled}
                    type={field.type}
                    style={field.style}
                    multiline={field.multiline}
                    rows={field.rows}
                    className={classes.heightsForm}
                    label={field.label}
                    name={field.name}
                    initialValue={field.value}
                    variant="outlined"
                    fullWidth
                    value={field.value}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={field.inputProps}
                    rowsMax={field.rowsMax}
                    autoFocus={field.autoFocus}
                  />
                </Grid>
              )
            }
          }
          if (field.class === 'datepicker') {
            return (
              <Grid item sm={field.sm} xs={field.xs} key={index}>
                <Field
                  component={DatePickerField}
                  strictManualDate={props.strictManualDate}
                  className={classes.heightsForm}
                  disabled={isSubmitting ? true : field.disabled}
                  label={field.label}
                  name={field.name}
                  format={field.format}
                  views={field.views}
                  disableFuture={field.disableFuture}
                  keepFocusOnSelect={field.keepFocusOnSelect}
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            )
          }
          if (field.class === 'autocomplete') {
            return (
              <Grid item sm={field.sm} xs={field.xs} key={index}>
                <FormikAutocomplete
                  key={field.name}
                  freeSolo={field.freeSolo}
                  disabled={isSubmitting ? true : field.disabled}
                  defaultValue={field.defaultValue}
                  disableClearable={field.disableClearable}
                  name={field.name}
                  options={field.options}
                  style={field.style}
                  clearOnEscape={field.clearOnEscape}
                  getOptionDisabled={field.getOptionDisabled}
                  // eslint-disable-next-line
                  getOptionLabel={(options) => eval(field.optionLabel)}
                  noOptionsText={field.noOptionsText}
                  endAdornment={field.endAdornment}
                  label={field.label}
                  onChange={(_, value, reason) => {
                    if (field.onChange) {
                      field.onChange(value, reason)
                    } else {
                      if (!value) {
                        setFieldValue(field.name, '')
                      } else {
                        setFieldValue(field.name, value[field.optionValue])
                      }
                    }
                  }}
                  onInputChange={(_, value) => {
                    if (field.onInputChange) {
                      field.onInputChange(value)
                    } else {
                      setFieldValue(field.name, value)
                    }
                  }}
                  sortBy={field.sortBy}
                  value={field.options.find((index) => index[field.optionValue] === field.value)}
                  groupBy={(options) => options[field.groupBy]}
                  onKeyDown={field.onKeyDown}
                />
              </Grid>
            )
          }
          if (field.class === 'custom') {
            return (
              <Grid item sm={field.sm} xs={field.xs}>
                {field.component}
              </Grid>
            )
          }
          return ''
        })}
      </Grid>
    </div>
  )
}
